import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Flex,
  Icon,
  ModalHeader,
  Text,
  Button,
  Heading,
} from '@chakra-ui/react'
import { useEffect } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { BsPeople } from 'react-icons/bs'
import { useSessionStorage } from 'usehooks-ts'
import Warning from '@/public/assets/icons/warning.svg'
import { LocalStorageKey } from '@/constants/localstorage'

export const CountryRestrictedModal = ({ onClose }: any) => {
  const { t } = useTranslation()
  const [ignore, setIgnore] = useSessionStorage(LocalStorageKey.CountryRestrictionIgnore, false)

  useEffect(() => {
    if (ignore) {
      onClose()
    }
  }, [ignore])

  return (
    <Modal size={'xl'} isOpen={true} closeOnOverlayClick={false} onClose={onClose} closeOnEsc={false}>
      <ModalOverlay />
      <ModalContent
        containerProps={{
          zIndex: '3000',
        }}
        marginLeft={2.5}
        marginRight={2.5}
      >
        <ModalHeader>
          <Flex gap={2} alignItems={'center'}>
            <Icon boxSize={6} color={'ninja.300'} as={BsPeople} />
            <Text fontSize="xl" fontWeight="700">
              {t('messages.country-restricted')}
            </Text>
          </Flex>
        </ModalHeader>

        <ModalBody pb={5}>
          <Flex mb={4} justifyContent={'center'}>
            <Warning />
          </Flex>
          <Heading mb={2} maxW={'320px'} mx={'auto'} textAlign={'center'} fontSize={'2xl'}>
            {t('messages.game-restricted-region')}
          </Heading>
          <Text mb={5} maxW={'400px'} mx={'auto'} textAlign={'center'} color={'ninja.100'} fontWeight={500}>
            {t('messages.vpn-disable')}
          </Text>
          <Button onClick={() => setIgnore(true)} h={14} rounded={'2xl'} w={'full'}>
            {t('messages.continue-watching')}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
